import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  typography: {
    fontFamily: 'Montserrat',
    button: {
      textTransform: 'none',
    },
  },
});
